module.exports = __webpack_public_path__ + "static/media/listingArticle.9572482a.png";